"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.color = void 0;

var _core = require("@styled-system/core"); // Only types
// eslint-disable-next-line import/no-extraneous-dependencies


var color = (0, _core.system)({
  textColor: {
    property: 'color',
    scale: 'colors'
  },
  bgColor: {
    property: 'backgroundColor',
    scale: 'colors'
  },
  opacity: true
});
exports.color = color;